/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

/*
* mbp-checkout/CART/LOAD action type is same as the loadcart action on mbp-pwa-ui
* this is done to keep the cart in both places updated
*/
const LOAD_CART = 'mbp-checkout/CART/LOAD';
const UPDATE_CART_SNAPSHOT = 'MFE/MBP-CHECKOUT/UPDATE/CART/SNAPSHOT';
const MFE_GET_CART = 'MFE/MBP-CHECKOUT/GET/CART';
const UPDATE_QTY = 'MFE/MBP-CHECKOUT/CART/UPDATE_QTY';
const CART_LOADED = 'MFE/MBP-CHECKOUT/CART/LOADED';
const CALL_HANDLE_CART_FAILURE = 'MFE/MBP-CHECKOUT/CALL_HANDLE_CART_FAILURE';
const CALL_PREPARE_CART = 'MFE/MBP-CHECKOUT/CALL_PREPARE_CART';
const CALL_PREPARE_CART_COMPLETED = 'MFE/MBP-CHECKOUT/CALL_PREPARE_CART_COMPLETED';

export default {
    UPDATE_CART_SNAPSHOT,
    LOAD_CART,
    MFE_GET_CART,
    UPDATE_QTY,
    CART_LOADED,
    CALL_HANDLE_CART_FAILURE,
    CALL_PREPARE_CART,
    CALL_PREPARE_CART_COMPLETED,
};
